import React__default, { useRef, useState, useContext, createContext, useMemo, useEffect, Fragment } from "react";
import { createPortal } from "react-dom";
import { useEvent as o } from "../../hooks/use-event.js";
import { useIsoMorphicEffect as n$1 } from "../../hooks/use-iso-morphic-effect.js";
import { useOnUnmount as c } from "../../hooks/use-on-unmount.js";
import { useOwnerDocument as n } from "../../hooks/use-owner.js";
import { useServerHandoffComplete as l } from "../../hooks/use-server-handoff-complete.js";
import { useSyncRefs as y$1, optionalRef as T } from "../../hooks/use-sync-refs.js";
import { usePortalRoot as a } from "../../internal/portal-force-root.js";
import { env as s } from "../../utils/env.js";
import { forwardRefWithAs as W$1, render as H } from "../../utils/render.js";
function D(p) {
  let r = a(), l2 = useContext(v), e = n(p), [o2, n$12] = useState(() => {
    var t;
    if (!r && l2 !== null) return (t = l2.current) != null ? t : null;
    if (s.isServer) return null;
    let u = e == null ? void 0 : e.getElementById("headlessui-portal-root");
    if (u) return u;
    if (e === null) return null;
    let a2 = e.createElement("div");
    return a2.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(a2);
  });
  return useEffect(() => {
    o2 !== null && (e != null && e.body.contains(o2) || e == null || e.body.appendChild(o2));
  }, [o2, e]), useEffect(() => {
    r || l2 !== null && n$12(l2.current);
  }, [l2, n$12, r]), o2;
}
let M = Fragment, N = W$1(function(r, l$1) {
  let e = r, o2 = useRef(null), n$2 = y$1(T((i) => {
    o2.current = i;
  }), l$1), u = n(o2), a2 = D(o2), [t] = useState(() => {
    var i;
    return s.isServer ? null : (i = u == null ? void 0 : u.createElement("div")) != null ? i : null;
  }), s$1 = useContext(y), b = l();
  return n$1(() => {
    !a2 || !t || a2.contains(t) || (t.setAttribute("data-headlessui-portal", ""), a2.appendChild(t));
  }, [a2, t]), n$1(() => {
    if (t && s$1) return s$1.register(t);
  }, [s$1, t]), c(() => {
    var i;
    !a2 || !t || (t instanceof Node && a2.contains(t) && a2.removeChild(t), a2.childNodes.length <= 0 && ((i = a2.parentElement) == null || i.removeChild(a2)));
  }), b ? !a2 || !t ? null : createPortal(H({ ourProps: { ref: n$2 }, theirProps: e, slot: {}, defaultTag: M, name: "Portal" }), t) : null;
});
function S(p, r) {
  let l2 = y$1(r), { enabled: e = true, ...o2 } = p;
  return e ? React__default.createElement(N, { ...o2, ref: l2 }) : H({ ourProps: { ref: l2 }, theirProps: o2, slot: {}, defaultTag: M, name: "Portal" });
}
let j = Fragment, v = createContext(null);
function W(p, r) {
  let { target: l2, ...e } = p, n2 = { ref: y$1(r) };
  return React__default.createElement(v.Provider, { value: l2 }, H({ ourProps: n2, theirProps: e, defaultTag: j, name: "Popover.Group" }));
}
let y = createContext(null);
function ee() {
  let p = useContext(y), r = useRef([]), l2 = o((n2) => (r.current.push(n2), p && p.register(n2), () => e(n2))), e = o((n2) => {
    let u = r.current.indexOf(n2);
    u !== -1 && r.current.splice(u, 1), p && p.unregister(n2);
  }), o$1 = useMemo(() => ({ register: l2, unregister: e, portals: r }), [l2, e, r]);
  return [r, useMemo(() => function({ children: u }) {
    return React__default.createElement(y.Provider, { value: o$1 }, u);
  }, [o$1])];
}
let I = W$1(S), J = W$1(W), te = Object.assign(I, { Group: J });
export {
  te as Portal,
  J as PortalGroup,
  ee as useNestedPortals
};
